<div>
  <div class="w-full p-5 rounded-2xl bg-white border border-smoke flex flex-col gap-4">
    <!-- Badges and actions-->
    <div class="flex justify-between">
      <div class="flex gap-2" (mouseenter)="p.open()" (mouseleave)="p.close()" [satPopoverAnchor]="p">
        @switch (status()) {
          @case (AdyenPayoutMethodStatus.VALID) {
            <ui-badge variant="success" appearance="subtle" value="Active"></ui-badge>
          }
          @case (AdyenPayoutMethodStatus.INVALID) {
            <ui-badge variant="warning" appearance="subtle" value="Needs verification"></ui-badge>
          }
          @case (AdyenPayoutMethodStatus.PENDING) {
            <ui-badge variant="gray" appearance="subtle" value="Pending"></ui-badge>
          }
          @case (AdyenPayoutMethodStatus.REJECTED) {
            <ui-badge variant="error" appearance="subtle" value="Rejected"></ui-badge>
          }
        }

        @if (isDefault()) {
          <ui-badge variant="gray" appearance="solid" value="Default"></ui-badge>
        }

        <sat-popover verticalAlign="below" horizontalAlign="start" #p>
          @if (verificationErrors()?.length > 0) {
            <div class="rounded-xl border my-2 border-smoke text-sm bg-white p-3 flex flex-col gap-1">
              <span class="text-night-darker leading-6">{{ verificationErrors()[0] }}</span>
              @if (verificationErrors().length > 1) {
                <span class="text-night-lighter leading-6"
                  >and {{ verificationErrors().length - 1 }}
                  {{ verificationErrors().length === 2 ? 'other item' : 'other items' }}</span
                >
              }
            </div>
          }
        </sat-popover>
      </div>

      @if (actions().length > 0) {
        <div
          class="rounded border border-smoke w-8 h-8 flex items-center justify-center strong cursor-pointer hover:bg-smoke-lighter leading-0 text-xs"
          [matMenuTriggerFor]="cardMenu">
          •••
        </div>

        <mat-menu #cardMenu="matMenu">
          @for (action of actions(); track action.id) {
            <button class="strong" mat-menu-item [ngClass]="action.classes" (click)="onActionClick(action.id)">
              {{ action.label }}
            </button>
          }
        </mat-menu>
      }
    </div>

    <!-- Title -->
    <strong class="truncate">{{ accountName() }}</strong>

    <!-- Number -->
    <div class="flex gap-3">
      <span *ngIf="lastFour()">•••• {{ lastFour() }}</span>
    </div>

    <!-- Bank name -->
    <div class="flex justify-between">
      <div class="flex gap-3">
        <!-- <ui-icon [icon]="'bank'" *ngIf="bankName()" /> -->
        <!-- Didn't know how to make the vertical height the same for an empty line. LOL! -->
        <span class="truncate text-sm text-night-lighter">{{ bankName() ?? '' }}&nbsp;</span>
      </div>
      <div class="flex-none">
        <sbnb-avatar-group
          *ngIf="properties()"
          [items]="properties()"
          [allItems]="allProperties()"
          [allItemsLabel]="'All properties'"
          [itemsForLabel]="accountName()"></sbnb-avatar-group>
      </div>
    </div>
  </div>

  <sbnb-cs-debug-item
    *ngIf="accountHolderId()"
    class="text__small"
    label="Account Holder ID"
    [value]="accountHolderId()"
    [link]="'https://ca-live.adyen.com/ca/ca/accounts/account-holders/details.shtml?id=' + accountHolderId()"
    (click)="$event.stopPropagation()"></sbnb-cs-debug-item>
</div>
